export default __webpack_public_path__ + "static/media/patient-cases.fe063aeb.svg";